import React, { useState, createContext } from "react";
import Navbar from "./components/navbar/Navbar";
import Main from "./components/main/Main";
import FetchData from "./api/api";
import "./App.css";

export const UserContext = createContext();
export const DataContext = createContext();

function App() {
  const [displayHomePage, setDisplayHomePage] = useState(true);
  const [data, setData] = useState([]);
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);

  return (
    <>
      <DataContext.Provider value={{ data, setData }}>
        <UserContext.Provider
          value={{
            displayHomePage,
            setDisplayHomePage,
            sidebarIsOpen,
            setSidebarIsOpen,
          }}
        >
          <Navbar />
          <Main />
        </UserContext.Provider>

        <FetchData />
      </DataContext.Provider>
    </>
  );
}

export default App;
